import React from 'react';
import { Card } from './ui/card';
import { MessageSquare, FileText, CheckCircle, Send } from 'lucide-react';

export const ProcessSection = () => {
  const steps = [
    {
      number: '01',
      icon: MessageSquare,
      title: 'Initial Consultation',
      description: 'Contact us for a free consultation. We discuss your visa needs and assess your eligibility.'
    },
    {
      number: '02',
      icon: FileText,
      title: 'Document Gathering',
      description: 'We provide a detailed checklist and guide you through collecting all necessary documents.'
    },
    {
      number: '03',
      icon: CheckCircle,
      title: 'Review & Preparation',
      description: 'Our experts review your documents, complete application forms, and ensure everything is perfect.'
    },
    {
      number: '04',
      icon: Send,
      title: 'Submission & Follow-up',
      description: 'We submit your application and provide ongoing support until you receive your visa.'
    }
  ];

  return (
    <section id="process" className="py-20 sm:py-24 lg:py-32 bg-gradient-subtle">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Our Simple Process
          </h2>
          <p className="text-lg text-muted-foreground">
            Four easy steps to your visa approval
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-16 left-full w-full h-0.5 bg-gradient-to-r from-primary to-secondary z-0" style={{ transform: 'translateX(-50%)' }} />
                )}
                
                <Card className="p-6 h-full border-2 hover:border-primary/50 transition-all duration-300 hover:shadow-xl relative z-10 bg-background">
                  <div className="text-6xl font-bold text-primary/10 absolute top-4 right-4">
                    {step.number}
                  </div>
                  
                  <div className="relative">
                    <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-gradient-primary mb-4">
                      <step.icon className="h-7 w-7 text-white" />
                    </div>
                    
                    <h3 className="text-xl font-semibold text-foreground mb-3">
                      {step.title}
                    </h3>
                    
                    <p className="text-muted-foreground leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
